import { useHeaders } from "@features/headers"
import {
  Button,
  CardActionArea,
  CardContent,
  CardMedia,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Card as MuiCard,
  Stack,
  TextField,
  Typography,
} from "@mui/material"
import Grid from "@mui/material/Grid"
// ...existing code...
import type { FC } from "react"
import { useEffect, useState } from "react"
import { useNewsletterStore } from "../store/newsletterStore"

interface Props {
  open: boolean
  onClose: () => void
}

const HeaderPickerDialog: FC<Props> = ({ open, onClose }) => {
  const { data, isLoading, error, refetch } = useHeaders()
  const setHeader = useNewsletterStore((s) => s.setHeader)
  const headerUrl = useNewsletterStore((s) => s.headerUrl)
  const setHeaderUrl = useNewsletterStore((s) => s.setHeaderUrl)
  // ...existing code...

  const [url, setUrl] = useState(headerUrl || "")
  useEffect(() => {
    if (open) setUrl(headerUrl || "")
  }, [open, headerUrl])

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Selecionar cabeçalho</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2} sx={{ mb: 2 }}>
          <TextField
            label="URL personalizado"
            placeholder="https://…/header.jpg"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            fullWidth
          />
          <div className="text-xs text-gray-600">
            Se definir um URL, este terá prioridade sobre os cabeçalhos
            listados.
          </div>
        </Stack>
        {isLoading && (
          <div className="py-4 text-sm text-gray-600">A carregar…</div>
        )}
        {error && (
          <div className="py-4 text-sm text-red-600">
            Erro ao carregar cabeçalhos.{" "}
            <button className="underline" onClick={() => refetch()}>
              Tentar novamente
            </button>
          </div>
        )}
        <Grid container spacing={2} sx={{ mt: 0 }}>
          {(data || []).map((h) => (
            <Grid key={h.id}>
              <MuiCard>
                <CardActionArea
                  onClick={() => {
                    setHeader(h)
                    setHeaderUrl(null)
                    onClose()
                  }}
                >
                  <CardMedia component="img" image={h.image} alt={h.name} />
                  <CardContent>
                    <Typography variant="body2" color="text.secondary">
                      {h.name}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </MuiCard>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setHeader(null)
            setHeaderUrl(url || null)
            onClose()
          }}
        >
          Usar URL personalizado
        </Button>
        <Button variant="contained" onClick={onClose}>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default HeaderPickerDialog
